<mat-sidenav-container class="sidebar-container">

    <mat-sidenav mode="side" [opened]="sidenavVisible" class="sidebar">


        <!-- Navigation Menu -->
        <div class="quick-actions">

            <mat-nav-list>
                @if (!hasError) {
                <mat-list-item *ngIf="!['/search-database','/new-hydrotest','/admin'].includes(router.url)">
                    <a [routerLink]="'/new-hydrotest'">
                        <mat-icon>assignment</mat-icon>
                        <span>Submit New Hydrotest</span>
                    </a>
                </mat-list-item>
                <mat-list-item *ngIf="!['/search-database','/new-hydrotest','/admin'].includes(router.url)">
                    <a [routerLink]="'/search-database'">
                        <mat-icon>search</mat-icon>
                        <span>Search Database</span>
                    </a>
                </mat-list-item>
                <mat-list-item *ngIf="['/search-database','/new-hydrotest','/admin'].includes(router.url)">
                    <a [routerLink]="''">
                        <mat-icon>home</mat-icon>
                        <span>Hydrotest Home</span>
                    </a>
                </mat-list-item>
                <mat-list-item *ngIf="!['/search-database','/new-hydrotest','/admin'].includes(router.url)">
                    <a href="pdf/BlankReport.pdf" target="_blank" class="blank-form-link">
                        <mat-icon>description</mat-icon>
                        <span>Blank Form</span>
                    </a>
                </mat-list-item>
                <mat-list-item *ngIf="router.url === '/admin'" class="incomplete-doc">
                    <a href="javascript:void(0)" (click)="downloadReport(2)">
                        <mat-icon>report</mat-icon>
                        <span>Incomplete Documentation Report</span>
                    </a>
                </mat-list-item>
                <mat-list-item *ngIf="router.url === '/admin'">
                    <a href="javascript:void(0)" (click)="downloadReport(3)">
                        <mat-icon>report</mat-icon>
                        <span>New Pipeline Segments</span>
                    </a>
                </mat-list-item>


                <mat-list-item>
                    <a href="assets/static/help.html" target="_blank">
                        <mat-icon>help_outline</mat-icon>
                        <span>{{ (router.url === '/search-database' || router.url === '/new-hydrotest') ? 'Help' : 'Hydrotest Help' }}</span>
                    </a>
                </mat-list-item>
                <mat-list-item *ngIf="!['/search-database','/new-hydrotest','/admin'].includes(router.url)">
                    <a href="assets/static/report.html" target="_blank">
                        <mat-icon>print</mat-icon>
                        <span>How to Print Reports</span>
                    </a>
                </mat-list-item>
                <mat-list-item *ngIf="!['/search-database','/new-hydrotest','/admin'].includes(router.url) && isAdmin">
                    <a [routerLink]="'/admin'" >
                        <mat-icon>admin_panel_settings</mat-icon>
                        <span>Administrative Tasks</span>
                    </a>
                </mat-list-item>
                }
                @else{
                <mat-list-item>
                    <a [routerLink]="''">
                        <mat-icon>home</mat-icon>
                        <span>Hydrotest Home </span>
                    </a>
                </mat-list-item>

                }

            </mat-nav-list>
        </div>
    </mat-sidenav>

    <mat-sidenav-content class="main-content" [class.no-margin]="!sidenavVisible">


        @if (hasError) {
        <app-error-page> </app-error-page>
        }

        @else {
        
        <div class="horzontal-menu" *ngIf="!sidenavVisible">
              <h4 class="search-heading" textAlign="center">Search Hydrostatic Test Records</h4>
            <mat-nav-list>
                <mat-list-item>
                    <a [routerLink]="''">
                        <span>Hydrotest Home </span>
                    </a>
                </mat-list-item>
                <mat-list-item>
                    <a [routerLink]="'/search-database'">
                        <span>Search Database</span>
                    </a>
                </mat-list-item>
            </mat-nav-list>
        </div>
        <!-- This will contain the main content -->
        <div class="content-placeholder" [ngClass]="{'horizontal-content': !sidenavVisible}">
            <router-outlet></router-outlet>
        </div>
        }
    </mat-sidenav-content>
</mat-sidenav-container>